import { initOnlineBookingThunk } from 'actions/onlineBooking/OnlineBookingActions';
import { OnlineBookingDisabled } from 'components/OnlineBooking/OnlineBookingDisabled/OnlineBookingDisabled';
import { OnlineBookingForm } from 'components/OnlineBooking/OnlineBookingForm';
import { LoadingOverlay } from 'components/UI/LoadingOverlay/LoadingOverlay';
import { useIsOnlineBookingEnabled } from 'hooks/useIsOnlineBookingEnabled';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import {
    getOnlineBookingLoading,
    getOnlineBookingStep
} from 'reducers/onlineBooking/OnlineBookingSelectors';
import { OnlineBookingStep } from 'types/OnlineBooking';

export const OnlineBookingPage: React.FC = () => {
    const dispatch = useDispatch();
    const isOLBEnabled = useIsOnlineBookingEnabled();
    const queryParams = useParams<{ slug: string }>();

    const marketplace = useSelector(getMarketplace);
    const currentStep = useSelector(getOnlineBookingStep);
    const isLoading = useSelector(getOnlineBookingLoading);

    React.useEffect(() => {
        if (marketplace.id === 0 || marketplace.slug !== queryParams.slug) {
            dispatch(initOnlineBookingThunk(queryParams.slug));
        }
        // eslint-disable-next-line
    }, []);

    if (isLoading && currentStep === OnlineBookingStep.Home) {
        return <LoadingOverlay />;
    }

    if (!isOLBEnabled) {
        return <OnlineBookingDisabled />;
    }

    return <OnlineBookingForm />;
};
